import { render } from "./provvigioni.vue?vue&type=template&id=340f6b32&ts=true"
import script from "./provvigioni.vue?vue&type=script&lang=ts"
export * from "./provvigioni.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__